import React from 'react';
import { Header } from '../../node_modules/semantic-ui-react';

export default function Awards(props) {
    return(
        <div className='section' id='education'>
            <Header as='h3'>
            Awards
            </Header>
            {/* <div className="section-content"> */}
                <Header as='h5' className="subsection-header" style={{fontWeight: '600', color: '#4183c4'}}>
                    Research
                </Header>
                    <div className="section-content">
                    <b>Best Paper Runner-up</b>, Workshop on Human Computation for Image and Video Analysis
                    <div class="detail">Oct. 2017, HCOMP 2017</div>
                    <b>Grand Prix</b>, Undergraduate Research Participation (URP) Program
                    <div class="detail">Jun. 2017, KAIST</div>
                    </div>
                <Header as='h5' className="subsection-header" style={{fontWeight: '600', color: '#4183c4'}}>
                    Others
                </Header>
                    <div className="section-content">
                        <b>Grand Prix Minister’s Award</b>, Industry-Academic Cooperation Project Contest 
                        <div class="detail">Nov. 2017, Ministry of Science and Technology</div>
                        <b>Grand Prix</b>, 2017 E*5 KAIST Start-up Competition
                        <div class="detail">Nov. 2017, KAIST; 12.5M Korean won award</div>
                        <b>Third Prize</b>, Start-up Award KAIST Hongneung 2017
                        <div class="detail">Oct. 2017, KAIST; 1M Korean won award</div>
                    </div>
            {/* </div> */}
        </div>
    )
}

// Nov. 2017
// Grand Prix, 2017 E*5 KAIST Start-up Competition
// KAIST; 12.5M Korean won award
// Nov. 2017
// Third Prize, Start-up Award KAIST Hongneung 2017
// KAIST; 1M Korean won award
// Oct. 2017
// Best Paper Runner-up, Workshop on Human Computation for Image and Video Analysis
// HCOMP 2017
// Jun. 2017
// Grand Prix, Undergraduate Research Participation (URP) Program
// KAIST



// WEBPACK FOOTER //
// ./src/components/Awards.jsx